import { stringify } from 'querystring';

import { createAction } from '@saucelabs/sl-util-redux';
import { replace, push } from 'connected-react-router';

import * as constants from './types';
import * as util from './../../util';

// push a new location to the history
export const pushPath = (pathname, params) => push({ pathname, search: `?${stringify(params)}` });

// read location from meta and replace queryString if location exists
export const handleLocationMeta = (action, getNewQueryParam) => (payload, meta) => (dispatch) => {
  const location = meta ? meta.location : null;
  const newQueryParams = location ? getNewQueryParam(location, payload) : null;
  const routeChangeMethod = location && location.action === 'push' ? push : replace;
  return Promise.all([
    dispatch(action(payload, meta)),
    ...(newQueryParams ?
      [dispatch(routeChangeMethod({ pathname: location.pathname, search: `?${stringify(newQueryParams)}` }))] : []),
  ]);
};


export const clearSelectedFilters = handleLocationMeta(
  createAction(constants.CLEAR_SELECTED_FILTERS), util.clearSelectedFilterTransformer);

export const selectDateFilter = handleLocationMeta(
  createAction(constants.SELECT_DATE_FILTER), util.selectedDateTransformer);

export const selectFilterItems = handleLocationMeta(
  createAction(constants.SELECT_FILTER_ITEMS), util.selectFilterTransformer);

export const setFiltersFromQueryParams = createAction(constants.SET_FILTERS_FROM_QUERY_PARAMS);

export const setFilterItems = createAction(constants.SET_FILTER_ITEMS);

export const removeFilterItem = handleLocationMeta(
  createAction(constants.REMOVE_FILTER_ITEM), util.removeFilterTransformer);
